import styled from 'styled-components';
import { ThemeColours } from '../../../styles/ThemeColours';
import {
  FONT_STACK,
  FontWeight,
  FontSize,
  STANDARD_TRANSITION,
  STANDARD_SHRINK,
} from '../../../styles/constants';
import { HIDE_SCROLL_BAR } from '../../../styles/mixins';
import { Button } from '../../Button/Button';
import IconLanguageGlobe from '../../icons/IconLanguageGlobe.svg';
import IconLanguageTranslate from '../../icons/IconLanguageTranslate.svg';

export const LanguageGlobeIcon = styled(IconLanguageGlobe)`
  height: 18px;
  margin-inline-end: 5px;
  width: 20px;
`;

export const LanguageTranslateIcon = styled(IconLanguageTranslate)`
  height: 21px;
  width: 21px;
`;

export const LanguagePickerModal = styled.div`
  direction: ltr;
  text-align: center;
`;

export const ModalTitle = styled.h2`
  ${FONT_STACK}
`;

export const ModalParagraph = styled.p`
  ${FONT_STACK}
  color: ${ThemeColours.mono700};
  font-size: 16px;
  line-height: 24px;
`;

export const CancelButton = styled(Button)`
  margin-top: 22px;
`;

export const ValueWrapper = styled.div`
  position: relative;
`;

export const TextValueWrapper = styled.div`
  margin-left: 28px;
`;

export const FloatingLanguageButton = styled(Button)`
  background-color: white;
  border: 0.5px solid rgba(226, 226, 226, 1);
  border-radius: 50%;
  box-shadow: 0px 2px 5px 0px rgba(0, 0, 0, 0.25);
  height: 56px;
  margin-inline-end: 12px;
  width: 56px;
`;

export const NavBarLanguageButton = styled.button`
  ${FONT_STACK};
  ${STANDARD_TRANSITION};
  ${HIDE_SCROLL_BAR};
  align-items: center;
  background-color: initial;
  border: 0;
  box-sizing: border-box;
  color: ${ThemeColours.mono700};
  cursor: pointer;
  display: flex;
  flex: 0 0 auto;
  font-size: ${FontSize.REGULAR};
  font-weight: ${FontWeight.REGULAR};
  height: 32px;
  justify-content: center;
  margin: 0 8px;
  padding: 0 8px;

  &:active {
    transform: scale(${STANDARD_SHRINK});
  }
`;
